define(['angular', 'angular-resource'], function (angular) {
    return angular
        .module('advertising.facebook', ['ngResource'])
        .factory('FacebookAds', [
            '$http',
            '$q',
            '$resource',
            '$rootScope',
            'Facebook',
            function ($http, $q, $resource, $rootScope, Facebook) {
                var resource = $resource(
                    $rootScope.Routing.generate('facebook_ads', {
                        _format: 'json',
                    }),
                    [],
                    {
                        activate: {
                            method: 'PUT',
                            params: { id: '@id' },
                            isArray: false,
                            url: decodeURIComponent(
                                $rootScope.Routing.generate(
                                    'activate_facebook_ad',
                                    { _format: 'json', adSet: ':id' }
                                )
                            ),
                        },
                        pause: {
                            method: 'PUT',
                            params: { id: '@id' },
                            isArray: false,
                            url: decodeURIComponent(
                                $rootScope.Routing.generate(
                                    'pause_facebook_ad',
                                    { _format: 'json', adSet: ':id' }
                                )
                            ),
                        },
                        query: {
                            method: 'GET',
                            isArray: true,
                        },
                        save: {
                            method: 'POST',
                            isArray: false,
                            url: decodeURIComponent(
                                $rootScope.Routing.generate(
                                    'create_facebook_ad',
                                    { _format: 'json' }
                                )
                            ),
                        },
                    }
                );

                var FacebookAds = {
                    create: function (newAd) {
                        return resource.save(newAd);
                    },
                    getAll: function () {
                        return resource.query();
                    },
                    permissions: ['ads_management', 'pages_show_list'],
                    getDailyBudget: function () {
                        return $http.get(
                            $rootScope.Routing.generate(
                                'get_facebook_daily_budget',
                                { _format: 'json' }
                            )
                        );
                    },
                    setDailyBudget: function (newBudget) {
                        return $http.put(
                            $rootScope.Routing.generate(
                                'set_facebook_daily_budget',
                                { _format: 'json' }
                            ),
                            { dailyBudget: newBudget }
                        );
                    },
                    setPage: function (newPageId) {
                        return $http.put(
                            $rootScope.Routing.generate('set_facebook_page', {
                                _format: 'json',
                            }),
                            { pageId: newPageId }
                        );
                    },
                    setAdAccount: function (newAdId) {
                        return $http.put(
                            $rootScope.Routing.generate(
                                'set_facebook_ad_account',
                                { _format: 'json' }
                            ),
                            { adId: newAdId }
                        );
                    },
                    setToken: function (newToken) {
                        return $http.put(
                            $rootScope.Routing.generate('set_facebook_token', {
                                _format: 'json',
                            }),
                            { token: newToken }
                        );
                    },
                    updateLoginStatus: function () {
                        var deferred = $q.defer();

                        $http
                            .get(
                                $rootScope.Routing.generate(
                                    'get_facebook_token'
                                )
                            )
                            .then(function (response) {
                                FacebookAds.token = response.data;

                                deferred.resolve(response.data);
                            });

                        return deferred.promise;
                    },
                };

                return FacebookAds;
            },
        ]);
});
